export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categoryName: string;
  coverImage: string;
  author: string;
  publishedAt: string;
  updatedAt: string;
  viewCount: number;
  commentCount: number;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
  readTime: number;
}

export const articles: Article[] = [
  {
    id: 'article-001',
    title: '某顶流男星深夜密会神秘女子，酒店共度三小时引发恋情猜测',
    slug: 'dingliu-nanxing-shenye-mihui',
    excerpt: '近日有网友拍到某当红顶流男星深夜与一名神秘女子先后进入某五星级酒店，据目击者称两人在酒店内停留超过三小时，直到凌晨才分别离开。此消息一出立刻引发网友热议，纷纷猜测该男子是否已有新恋情。',
    content: `<p>近日，有网友在社交平台晒出一组照片，称在某五星级酒店附近拍到某顶流男星深夜密会神秘女子。据该网友描述，当晚约11点左右，该男星戴着口罩和帽子低调现身酒店地下车库，随后一名身材高挑的女子也出现在同一地点，两人一前一后进入电梯。</p>
    <p>目击者表示，两人在酒店内停留超过三个小时，直到凌晨两点左右才分别离开。值得注意的是，该女子离开时换了一身衣服，这一细节更是引发了网友的无限遐想。</p>
    <p>消息传出后，该男星的粉丝群体迅速反应，有人表示"相信偶像"，也有人认为"艺人也有私生活"。不过截至目前，该男星及其工作室均未对此事做出任何回应。</p>
    <p>据知情人士透露，该神秘女子疑似某知名模特公司签约模特，两人此前曾在某时尚活动上有过交集。如果恋情属实，这将是该男星入行以来首次公开的恋情。</p>
    <p>业内人士分析认为，在当下娱乐圈环境下，顶流艺人公开恋情需要极大的勇气，因为这可能会影响其商业价值和粉丝基础。不过近年来也有不少艺人选择公开恋情并获得粉丝祝福的先例。</p>
    <p>我们将持续关注此事的后续进展。</p>`,
    categoryId: 'mingxing-bagua',
    categoryName: '明星八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20scene%20of%20a%20luxury%20hotel%20lobby%20at%20night%20with%20a%20mysterious%20silhouette%20figure%20walking%20through%20dim%20golden%20lighting%2C%20paparazzi%20aesthetic%2C%20dramatic%20moody%20atmosphere%2C%20warm%20amber%20tones%2C%20luxurious%20interior%20with%20marble%20floors%2C%20elegant%20but%20secretive%20vibe%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field&width=800&height=500&seq=article-001-cover&orientation=landscape',
    author: '黑料君',
    publishedAt: '2026-08-06T22:30:00Z',
    updatedAt: '2026-08-07T09:00:00Z',
    viewCount: 125800,
    commentCount: 2341,
    tags: ['恋情曝光', '顶流男星', '酒店密会'],
    isHot: true,
    isExclusive: false,
    readTime: 5,
  },
  {
    id: 'article-002',
    title: '独家：知名网红直播带货翻车，产品被曝存在严重质量问题',
    slug: 'zhiming-wanghong-zhibo-fanche',
    excerpt: '黑料网独家获悉，某拥有千万粉丝的知名网红近期直播带货的一款美妆产品被多位消费者投诉存在严重质量问题，使用后出现过敏、红肿等症状。目前涉事品牌方已紧急下架相关产品。',
    content: `<p>黑料网独家获悉，拥有超过1500万粉丝的知名网红"XX"近期在其直播间大力推荐的一款国产美妆产品，近日被大量消费者投诉存在严重质量问题。</p>
    <p>据多位消费者反映，使用该产品后出现了不同程度的过敏反应，包括面部红肿、瘙痒、起疹等症状，甚至有人因此就医治疗。消费者表示，正是因为信任该网红的推荐才购买了这款产品，没想到会出现如此严重的质量问题。</p>
    <p>记者调查发现，该产品的生产厂家此前曾因产品质量问题被相关部门处罚过，但该网红在直播中并未提及这一情况，反而大力鼓吹产品的"天然成分"和"零刺激"等卖点。</p>
    <p>事件发酵后，该网红的社交媒体评论区被愤怒的消费者"攻陷"，大量网友要求其公开道歉并承担赔偿责任。然而截至目前，该网红仍未对此事做出正面回应，仅通过助理发布了一条含糊其辞的声明。</p>
    <p>涉事品牌方已紧急将相关产品从各大电商平台下架，并表示将配合调查。市场监管部门也介入此事，将对该产品进行进一步的质量检测。</p>
    <p>这并非该网红第一次陷入带货争议，此前其推荐的多款产品也曾被质疑存在虚假宣传的问题。业内人士指出，网红带货行业亟需更严格的监管机制。</p>`,
    categoryId: 'wanghong-baoliao',
    categoryName: '网红爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20livestream%20studio%20with%20ring%20lights%20and%20beauty%20products%20scattered%20on%20a%20table%2C%20moody%20atmosphere%20with%20warning%20red%20accents%2C%20cinematic%20lighting%2C%20product%20photography%20style%2C%20beauty%20skincare%20products%20with%20caution%20tape%2C%20investigative%20journalism%20aesthetic&width=800&height=500&seq=article-002-cover&orientation=landscape',
    author: '爆料小助手',
    publishedAt: '2026-08-06T18:00:00Z',
    updatedAt: '2026-08-07T08:00:00Z',
    viewCount: 89300,
    commentCount: 1856,
    tags: ['网红爆料', '直播带货', '产品质量'],
    isHot: true,
    isExclusive: true,
    readTime: 6,
  },
  {
    id: 'article-003',
    title: '某女星被曝学历造假，真实学历仅为初中毕业引发轩然大波',
    slug: 'nvxing-xueli-zaojia',
    excerpt: '近日有网友扒出某知名女星的学历信息存在严重造假嫌疑，其公开宣称的海外名校硕士学历被证实系伪造，真实学历仅为初中毕业。此事在网络上引发广泛讨论。',
    content: `<p>娱乐圈学历造假风波再起。近日，有"学历打假"网友通过深入调查发现，某知名女星公开宣称的海外名校硕士学历存在严重造假嫌疑。</p>
    <p>该女星此前在多个公开场合和采访中均表示自己毕业于某国外知名大学的硕士学位，这一"学霸人设"也为其赢得了不少粉丝的喜爱和品牌代言。然而根据网友的调查，该女星实际上在初中毕业后便进入社会，并未完成高中学业，更不用说所谓的海外名校硕士。</p>
    <p>网友提供的证据显示，该女星在15岁时便已在某城市的服装批发市场做导购员，与其声称的求学经历存在明显的时间线矛盾。此外，该国外大学的学生数据库中并未查询到该女星的任何学籍记录。</p>
    <p>此事曝光后，该女星的社交媒体账号评论区瞬间沦陷，大量网友表达失望和愤怒。"人设崩塌"、"学历造假零容忍"等话题迅速登上热搜。</p>
    <p>圈内人士分析认为，学历造假在娱乐圈并非个案，但如此明目张胆的造假行为仍属罕见。这不仅涉及对公众的欺骗，也可能构成对合作品牌方的欺诈。</p>`,
    categoryId: 'mingxing-bagua',
    categoryName: '明星八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20conceptual%20image%20of%20a%20torn%20diploma%20certificate%20on%20a%20dark%20desk%20under%20spotlight%2C%20investigative%20journalism%20mood%2C%20dark%20and%20moody%20atmosphere%20with%20warm%20spotlight%2C%20symbolic%20of%20academic%20fraud%20exposure%2C%20cinematic%20lighting&width=800&height=500&seq=article-003-cover&orientation=landscape',
    author: '黑料君',
    publishedAt: '2026-08-05T14:00:00Z',
    updatedAt: '2026-08-06T10:00:00Z',
    viewCount: 256400,
    commentCount: 4521,
    tags: ['学历造假', '人设崩塌', '女星爆料'],
    isHot: true,
    isExclusive: false,
    readTime: 4,
  },
  {
    id: 'article-004',
    title: '热门综艺录制现场爆发冲突，两位嘉宾当场翻脸互骂',
    slug: 'zongyi-luzhi-chongtu',
    excerpt: '据现场观众爆料，某热门综艺最新一期录制过程中，两位常驻嘉宾因游戏环节产生争执，随后爆发激烈冲突，双方当场翻脸互骂，导致录制一度中断。',
    content: `<p>综艺节目录制现场再爆冲突。据参与某热门综艺最新一期录制现场的多位观众爆料，两位常驻嘉宾在游戏环节中因胜负判定问题产生激烈争执，最终演变成当场翻脸互骂的局面。</p>
    <p>据现场观众描述，当时正在进行一个竞技类游戏环节，两位嘉宾因对游戏规则的解读产生分歧。起初只是争论，随后情绪逐渐升级，其中一位嘉宾直接拍桌而起，另一位也不甘示弱地站起来回击。两人互相指责对方"耍赖"、"不尊重人"，言辞相当激烈。</p>
    <p>节目组工作人员紧急介入调停，录制被迫中断约40分钟。据称导演组进行了紧急协调，两位嘉宾在工作人员的劝说下勉强完成了后续录制，但全程几乎没有互动和交流。</p>
    <p>消息传出后，网友对此事的看法两极分化。支持A嘉宾的粉丝认为B嘉宾确实存在违规行为，而B嘉宾的粉丝则坚称是A嘉宾小题大做。双方粉丝在社交平台上展开了激烈的"键盘大战"。</p>
    <p>业内人士表示，综艺节目中的冲突并非罕见，但如此激烈的当众翻脸仍属少见。考虑到该节目的收视率和影响力，这一事件可能会对节目口碑产生一定影响。</p>`,
    categoryId: 'zongyi-neimu',
    categoryName: '综艺内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20TV%20studio%20set%20with%20bright%20stage%20lights%20and%20two%20empty%20chairs%20facing%20each%20other%20in%20confrontation%2C%20reality%20show%20aesthetic%2C%20tension%20and%20drama%20atmosphere%2C%20colorful%20set%20design%20with%20moody%20overtones%2C%20cinematic%20composition&width=800&height=500&seq=article-004-cover&orientation=landscape',
    author: '综艺观察员',
    publishedAt: '2026-08-05T10:00:00Z',
    updatedAt: '2026-08-05T16:00:00Z',
    viewCount: 198700,
    commentCount: 3210,
    tags: ['综艺撕逼', '录制冲突', '内幕爆料'],
    isHot: true,
    isExclusive: false,
    readTime: 5,
  },
  {
    id: 'article-005',
    title: '独家深挖：某知名歌手涉嫌偷税漏税，金额或高达数千万元',
    slug: 'zhiming-geshou-toushui',
    excerpt: '黑料网从多方渠道独家获悉，某知名歌手因涉嫌偷税漏税正在接受税务部门调查，涉案金额据称高达数千万元。如查实，该歌手可能面临巨额罚款甚至刑事责任。',
    content: `<p>黑料网从多方渠道独家获悉，某在华语乐坛具有极高知名度的歌手目前正在接受税务部门的秘密调查，涉嫌通过多种方式偷逃税款，涉案金额据称高达数千万元。</p>
    <p>据知情人士透露，该歌手涉嫌通过设立空壳公司、签订"阴阳合同"、虚报演出费用等方式进行税务规避。税务部门已经掌握了大量相关证据，调查已进入实质性阶段。</p>
    <p>该歌手近年来商业价值持续攀升，演唱会、综艺节目、品牌代言等收入渠道众多，但其申报的个人所得税却与其公开收入严重不符。业内人士估算，仅其最近一轮巡回演唱会的收入就超过一亿元，但税务申报却不足其十分之一。</p>
    <p>如果偷税漏税行为被查实，该歌手可能面临补缴税款、加收滞纳金以及数倍罚款的处罚。在情节严重的情况下，甚至可能面临刑事责任。</p>
    <p>此消息一出，与该歌手有合作关系的多个品牌方高度关注，部分品牌已开始评估可能的影响。该歌手近期原定的几场商业活动也出现了临时变动的迹象。</p>
    <p>值得注意的是，近年来税务部门对娱乐圈的税务监管力度持续加强，已有多位艺人因税务问题受到查处，整个行业的税务合规意识正在逐步提升。</p>`,
    categoryId: 'dujia-neirong',
    categoryName: '独家内容',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20moody%20dark%20scene%20of%20financial%20documents%20and%20tax%20forms%20scattered%20on%20a%20luxurious%20desk%20with%20gold%20accents%2C%20red%20stamp%20marks%20visible%2C%20investigative%20atmosphere%2C%20dramatic%20shadows%2C%20wealth%20and%20corruption%20theme%2C%20cinematic%20noir%20style&width=800&height=500&seq=article-005-cover&orientation=landscape',
    author: '黑料君',
    publishedAt: '2026-08-04T20:00:00Z',
    updatedAt: '2026-08-05T12:00:00Z',
    viewCount: 342100,
    commentCount: 5678,
    tags: ['偷税漏税', '知名歌手', '独家爆料'],
    isHot: true,
    isExclusive: true,
    readTime: 6,
  },
  {
    id: 'article-006',
    title: '某男团成员被曝与粉丝私下交往，聊天记录流出内容露骨',
    slug: 'nantuan-chengyuan-fensi-jiaowang',
    excerpt: '近日，某当红男团成员被曝与多名粉丝保持私下联系，部分聊天记录在网络上流出，内容尺度之大令人震惊。此事在饭圈引发轩然大波。',
    content: `<p>饭圈再爆丑闻。近日网上流出一组聊天记录截图，显示某当红男团的一名人气成员与多名粉丝保持着超出正常范围的私下联系。</p>
    <p>根据流出的聊天记录显示，该成员不仅主动添加粉丝的私人联系方式，还会在深夜与粉丝进行长时间的私密对话。更令人震惊的是，部分对话内容尺度极大，涉及大量不当言论和暗示性内容。</p>
    <p>据爆料的粉丝称，该成员通过社交平台的私信功能主动联系粉丝，以"想更了解支持自己的人"为由建立联系。在取得信任后，对话内容逐渐升级，从普通的嘘寒问暖发展到了过界的程度。</p>
    <p>事件曝光后，该男团的粉丝社群出现了严重分裂。一部分粉丝选择维护偶像，声称聊天记录系伪造；而另一部分粉丝则表达了极度的失望和愤怒，要求该成员及其经纪公司给出合理解释。</p>
    <p>经纪公司方面截至目前保持沉默。业内分析人士认为，如果聊天记录属实，这不仅将对该成员个人形象造成毁灭性打击，也可能连累整个男团的商业价值和未来发展。</p>`,
    categoryId: 'mingxing-bagua',
    categoryName: '明星八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20smartphone%20screen%20displaying%20chat%20messages%20with%20dramatic%20red%20glow%2C%20mysterious%20atmosphere%2C%20digital%20privacy%20breach%20concept%2C%20dark%20background%20with%20neon%20light%20reflections%2C%20cyber%20drama%20aesthetic%2C%20cinematic%20closeup&width=800&height=500&seq=article-006-cover&orientation=landscape',
    author: '饭圈观察员',
    publishedAt: '2026-08-04T15:00:00Z',
    updatedAt: '2026-08-05T08:00:00Z',
    viewCount: 456200,
    commentCount: 8923,
    tags: ['男团', '粉丝交往', '聊天记录'],
    isHot: true,
    isExclusive: false,
    readTime: 5,
  },
  {
    id: 'article-007',
    title: '知名模特疑似整容失败，近照面部僵硬变形引热议',
    slug: 'zhiming-mote-zhengrong-shibai',
    excerpt: '近日一位知名模特的最新活动照片在网络上引发热议，其面部与之前相比出现了明显的僵硬和变形，被网友质疑整容失败。多位医美专家也对此进行了分析。',
    content: `<p>整容话题再次成为娱乐圈焦点。近日，一位在国际T台上具有相当影响力的知名模特出席某品牌活动时的照片引发了广泛讨论。</p>
    <p>从活动现场流出的照片可以看到，该模特的面部表情显得异常僵硬，尤其是苹果肌和嘴唇区域出现了不自然的肿胀和不对称现象。与其几个月前的照片对比，面部的变化相当明显。</p>
    <p>多位医美行业的专业人士在看过照片后表示，该模特很可能进行了面部填充和唇部注射等项目，但从效果来看明显"过度"了。一位不愿透露姓名的医美医生分析称："从面部特征来看，填充物的量和位置都不太理想，导致了面部的'塑料感'。"</p>
    <p>模特行业对容貌的要求极高，行业内因整容导致事业受挫的案例并不罕见。该模特此前以自然清新的形象著称，此次的形象变化可能会影响到她与多个品牌的合作关系。</p>
    <p>有趣的是，该模特的经纪人在被媒体问及此事时，仅以"状态不好"和"拍摄角度问题"作为解释，并未正面回应整容质疑。</p>`,
    categoryId: 'mingxing-bagua',
    categoryName: '明星八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fashion%20runway%20scene%20with%20dramatic%20lighting%20and%20a%20cosmetic%20mirror%20reflecting%20distorted%20beauty%20concept%2C%20avant-garde%20fashion%20photography%20style%2C%20dramatic%20shadows%20and%20highlights%2C%20editorial%20beauty%20aesthetic%20with%20dark%20undertones&width=800&height=500&seq=article-007-cover&orientation=landscape',
    author: '时尚观察家',
    publishedAt: '2026-08-03T12:00:00Z',
    updatedAt: '2026-08-04T09:00:00Z',
    viewCount: 289300,
    commentCount: 4120,
    tags: ['整容风波', '模特', '面部变形'],
    isHot: false,
    isExclusive: false,
    readTime: 4,
  },
  {
    id: 'article-008',
    title: '独家：某头部网红涉嫌虚假宣传被立案调查，合作品牌纷纷解约',
    slug: 'toubu-wanghong-xujia-xuanchuan',
    excerpt: '黑料网独家获悉，某拥有超过2000万粉丝的头部网红因涉嫌多起虚假宣传被市场监管部门立案调查。消息传出后，其合作的多个品牌已紧急宣布解约。',
    content: `<p>网红行业监管风暴再起。黑料网独家获悉，一位拥有超过2000万粉丝的头部网红日前因涉嫌多起虚假宣传行为被市场监管部门正式立案调查。</p>
    <p>据了解，该网红在过去一年中为超过50个品牌进行过推广，涉及美妆、食品、服饰等多个品类。但多名消费者投诉其在直播中夸大产品功效、虚构使用效果，甚至推荐一些根本未取得相关资质的产品。</p>
    <p>市场监管部门在初步调查中发现，该网红推广的一款"神奇减肥产品"实际上只是普通的膳食补充剂，但其在直播中宣称"一周能瘦十斤"、"无需运动和节食"，存在明显的虚假宣传嫌疑。类似的问题还出现在其推广的多款美妆和保健产品中。</p>
    <p>消息传出后，与该网红有合作关系的多个知名品牌纷纷发布声明，宣布终止与该网红的全部合作。据业内人士估算，仅解约造成的直接经济损失就将超过千万元。</p>
    <p>该事件也引发了整个网红行业对合规经营的反思。多位MCN机构负责人表示，将加强旗下网红的内容审核和合规培训，避免类似问题的发生。</p>`,
    categoryId: 'wanghong-baoliao',
    categoryName: '网红爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20smartphone%20screen%20showing%20a%20livestream%20with%20warning%20signs%20and%20red%20alerts%2C%20digital%20influencer%20marketing%20theme%2C%20dark%20atmosphere%20with%20glowing%20screen%20light%2C%20investigative%20journalism%20aesthetic%2C%20dramatic%20contrast&width=800&height=500&seq=article-008-cover&orientation=landscape',
    author: '爆料小助手',
    publishedAt: '2026-08-03T09:00:00Z',
    updatedAt: '2026-08-03T16:00:00Z',
    viewCount: 167800,
    commentCount: 2934,
    tags: ['网红爆料', '虚假宣传', '立案调查'],
    isHot: true,
    isExclusive: true,
    readTime: 5,
  },
  {
    id: 'article-009',
    title: '某选秀节目导演被曝潜规则选手，多名参赛者勇敢发声',
    slug: 'xuanxiu-dirctor-qian-guize',
    excerpt: '某热门选秀节目的导演近日被多名往届参赛选手联名指控存在潜规则行为，声称曾遭受不公平对待和不当要求。此事件引发了公众对选秀节目公正性的广泛质疑。',
    content: `<p>选秀节目的"潜规则"问题再次浮出水面。近日，某热门选秀节目的多名往届参赛选手联合发声，指控该节目某位导演存在严重的潜规则行为。</p>
    <p>据选手们描述，该导演在节目录制期间多次以"晋级"、"镜头分配"、"后续资源"等为筹码，向参赛选手提出各种不当要求。如果不配合，选手的镜头会被大幅删减，甚至被恶意剪辑成负面形象。</p>
    <p>一位已经退出娱乐圈的前选手在接受采访时表示："当时我们都很年轻，为了实现梦想参加了这个节目，但没想到会遇到这样的事情。很多人因为害怕得罪导演而选择了忍气吞声，但这对我们来说太不公平了。"</p>
    <p>另一位选手则透露，该导演曾在深夜单独约谈多名选手，要求在非工作时间到其房间"讨论节目内容"，这种行为在当时就引起了选手们的不安，但由于缺乏证据和担心报复，没有人敢于公开。</p>
    <p>事件曝光后，该选秀节目的官方账号评论区被网友"攻陷"，大量网友要求节目组彻查此事并给出交代。该节目的多个赞助品牌也表示高度关注。</p>`,
    categoryId: 'zongyi-neimu',
    categoryName: '综艺内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20backstage%20area%20of%20a%20talent%20show%20with%20bright%20stage%20lights%20in%20the%20distance%2C%20dramatic%20contrast%20between%20light%20and%20shadow%2C%20empty%20corridor%20with%20a%20single%20figure%20silhouette%2C%20mysterious%20and%20tense%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=article-009-cover&orientation=landscape',
    author: '综艺观察员',
    publishedAt: '2026-08-02T16:00:00Z',
    updatedAt: '2026-08-03T10:00:00Z',
    viewCount: 523100,
    commentCount: 9120,
    tags: ['选秀节目', '潜规则', '综艺内幕'],
    isHot: true,
    isExclusive: false,
    readTime: 6,
  },
  {
    id: 'article-010',
    title: '知名音乐人被前妻爆料婚内出轨，多段录音证据曝光',
    slug: 'yinyueren-hunnei-chugui',
    excerpt: '一位在华语乐坛拥有举足轻重地位的知名音乐制作人，近日被前妻通过社交媒体爆料婚内出轨，并公开了多段录音证据。这些录音内容详细记录了当事人的出轨行为。',
    content: `<p>华语乐坛再爆丑闻。一位拥有"金牌制作人"称号的知名音乐人近日被其前妻在社交媒体上实名爆料，指控其在婚姻存续期间多次出轨，并公开了多段录音作为证据。</p>
    <p>前妻发布的爆料长文详细描述了该音乐人在婚内与多名女性保持不当关系的经过。她表示，自己忍耐多年，但对方不仅没有丝毫悔改，反而变本加厉，最终导致婚姻破裂。</p>
    <p>更引人关注的是，前妻公开的录音中清晰地记录了该音乐人与出轨对象的通话内容，其中包括大量露骨的对话和不正当关系的细节。这些录音的真实性已得到多位音频鉴定专家的初步确认。</p>
    <p>该音乐人在乐坛的地位极高，曾为多位一线歌手制作过热门歌曲，其专业口碑一直很好。此次个人生活方面的爆料，无疑将对其职业生涯产生重大影响。</p>
    <p>截至目前，该音乐人方面尚未对此事做出任何回应。其工作室的电话也一直处于无人接听状态。与该音乐人有合作关系的多位歌手也保持沉默，未就此事件发表任何看法。</p>`,
    categoryId: 'yinyue-quan',
    categoryName: '音乐圈',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20moody%20music%20studio%20scene%20with%20recording%20equipment%20and%20scattered%20audio%20tapes%2C%20dark%20and%20dramatic%20atmosphere%2C%20warm%20recording%20light%20contrasting%20with%20dark%20shadows%2C%20music%20production%20aesthetic%2C%20emotional%20and%20tense%20mood&width=800&height=500&seq=article-010-cover&orientation=landscape',
    author: '音乐圈内人',
    publishedAt: '2026-08-02T11:00:00Z',
    updatedAt: '2026-08-02T18:00:00Z',
    viewCount: 387600,
    commentCount: 6234,
    tags: ['婚内出轨', '音乐人', '录音证据'],
    isHot: true,
    isExclusive: false,
    readTime: 5,
  },
  {
    id: 'article-011',
    title: '某女团成员合约纠纷升级，经纪公司被指强迫签订不平等条约',
    slug: 'nvtuang-heyue-jiufen',
    excerpt: '某知名女团的一名成员日前通过律师发表声明，指控经纪公司强迫其签订严重不平等的合约，包括超长年限、极低分成比例和严苛的限制条款。合同纠纷正式进入法律程序。',
    content: `<p>偶像团体合约纠纷再起波澜。某知名女团的一名成员日前通过代理律师发表正式声明，指控其所属经纪公司存在多项严重侵害艺人权益的行为。</p>
    <p>根据律师声明，该成员与经纪公司签订的合约存在多项明显不公平的条款：合约期限长达15年，几乎是艺人整个职业生涯的黄金期；收入分成比例严重失衡，艺人仅能获得总收入的5%；此外，合约中还有大量限制人身自由的条款，包括禁止恋爱、限制社交活动等。</p>
    <p>该成员在声明中表示，自己是在未成年时期被星探发现后签约的，当时对合约内容并不完全理解，监护人也未能充分保护其权益。如今成年后，她才逐渐认识到这份合约的严重不公平性。</p>
    <p>经纪公司方面则坚称合约是双方自愿签订的，具有完全的法律效力，并表示将采取法律手段维护自身权益。公司发言人称："我们在培养艺人方面投入了大量资源，艺人走红后想要单方面解约是不合理的。"</p>
    <p>此事件引发了公众对偶像经纪行业乱象的广泛关注。多位法律专家指出，偶像经纪行业的合约问题由来已久，亟需行业规范和立法的进一步完善。</p>`,
    categoryId: 'mingxing-bagua',
    categoryName: '明星八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20legal%20document%20with%20broken%20chains%20symbolizing%20freedom%20from%20unfair%20contract%2C%20dark%20background%20with%20warm%20spotlight%2C%20kpop%20entertainment%20industry%20theme%2C%20powerful%20symbolic%20imagery%2C%20cinematic%20composition%20with%20dramatic%20lighting&width=800&height=500&seq=article-011-cover&orientation=landscape',
    author: '黑料君',
    publishedAt: '2026-08-01T14:00:00Z',
    updatedAt: '2026-08-02T08:00:00Z',
    viewCount: 215400,
    commentCount: 3876,
    tags: ['合约纠纷', '女团', '不平等条约'],
    isHot: false,
    isExclusive: false,
    readTime: 5,
  },
  {
    id: 'article-012',
    title: '独家：某演艺公司老板涉嫌性骚扰多名旗下艺人被警方带走',
    slug: 'yanyi-gongsi-laoban-xingsaorao',
    excerpt: '黑料网独家获悉，某知名演艺经纪公司的老板因涉嫌对旗下多名艺人实施性骚扰，日前已被警方带走协助调查。据悉已有至少五名受害者向警方提供了证词和证据。',
    content: `<p>娱乐圈大地震。黑料网从多个独立渠道独家确认，某在业内具有相当影响力的演艺经纪公司老板，因涉嫌对旗下多名艺人实施性骚扰，已于近日被警方带走协助调查。</p>
    <p>据了解，此次调查源于多名受害者的联合举报。截至目前，已有至少五名曾在该公司工作的艺人向警方提供了详细的证词和相关证据。受害者们描述了在该老板手下工作期间遭受的各种形式的性骚扰行为。</p>
    <p>一位不愿透露姓名的前公司员工向黑料网透露："这些事情在圈内其实早有耳闻，但大家都因为害怕得罪人而不敢说。这次终于有人站出来了，希望能还受害者一个公道。"</p>
    <p>该演艺公司在业内颇有影响力，旗下签约了多位知名艺人，近年来制作的多部影视作品也取得了不错的市场反响。该公司老板的"出事"，无疑将对公司的正常运营产生重大影响。</p>
    <p>消息传出后，该公司旗下的多位艺人通过社交媒体表达了对事件的震惊和关注。部分艺人表示正在考虑通过法律途径解除与公司的合约关系。</p>`,
    categoryId: 'dujia-neirong',
    categoryName: '独家内容',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20office%20building%20silhouette%20with%20police%20car%20lights%20reflecting%20in%20windows%2C%20night%20scene%2C%20tense%20and%20dramatic%20atmosphere%2C%20corporate%20scandal%20theme%2C%20cinematic%20noir%20style%20with%20urban%20night%20setting&width=800&height=500&seq=article-012-cover&orientation=landscape',
    author: '黑料君',
    publishedAt: '2026-08-01T09:00:00Z',
    updatedAt: '2026-08-01T20:00:00Z',
    viewCount: 678900,
    commentCount: 12345,
    tags: ['性骚扰', '演艺公司', '独家爆料'],
    isHot: true,
    isExclusive: true,
    readTime: 6,
  },
  {
    id: 'article-013',
    title: '某歌手新专辑销量被质疑造假，粉丝集资刷榜行为曝光',
    slug: 'geshou-zhuanji-xiaoliang-zaojia',
    excerpt: '近日有音乐数据博主通过数据分析发现，某当红歌手的新专辑销量存在大量异常数据，疑似通过粉丝集资大规模刷榜。此行为引发了音乐圈关于数据真实性的激烈讨论。',
    content: `<p>音乐榜单的公信力再次受到挑战。近日，一位专注于音乐数据分析的博主发布了一份详细报告，指出某当红歌手的新专辑销量数据存在大量异常。</p>
    <p>报告显示，在该专辑发售的24小时内，出现了大量来自相同IP地址的重复购买记录，且购买时间高度集中在凌晨时段。数据分析认为，这很可能是粉丝后援会组织的集中"冲销量"行为。</p>
    <p>更令人关注的是，该博主的追踪调查发现，这些"冲销量"的资金来源于粉丝后援会组织的集资活动。在短短一周内，后援会通过各种渠道募集了超过500万元的资金用于购买专辑和打榜。</p>
    <p>音乐行业评论人士指出，粉丝集资冲销量刷榜单的行为已经严重扭曲了音乐市场的正常竞争秩序，使得真正优秀的音乐作品难以获得应有的认可。这种行为不仅欺骗了公众，也欺骗了广告商和合作方。</p>
    <p>截至目前，该歌手及其经纪公司均未对此事做出回应。但该专辑在各大音乐平台的评论区已经出现了大量关于此事的讨论，支持者和批评者各执一词。</p>`,
    categoryId: 'yinyue-quan',
    categoryName: '音乐圈',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20music%20charts%20and%20data%20analytics%20with%20red%20warning%20markers%2C%20music%20album%20covers%20in%20background%2C%20dark%20data-driven%20atmosphere%2C%20digital%20dashboard%20aesthetic%2C%20investigative%20journalism%20style%2C%20dramatic%20contrast&width=800&height=500&seq=article-013-cover&orientation=landscape',
    author: '音乐圈内人',
    publishedAt: '2026-07-31T16:00:00Z',
    updatedAt: '2026-08-01T09:00:00Z',
    viewCount: 178900,
    commentCount: 2987,
    tags: ['专辑销量', '数据造假', '粉丝集资'],
    isHot: false,
    isExclusive: false,
    readTime: 4,
  },
  {
    id: 'article-014',
    title: '某美食网红被曝后厨卫生堪忧，直播间的精致美食实为团队代做',
    slug: 'meishi-wanghong-houchu-weisheng',
    excerpt: '一位以"家庭厨房"人设走红的美食网红近日被曝光实际后厨卫生状况堪忧，且直播中展示的精致美食并非其亲手制作，而是由专业团队在另一个厨房代做。',
    content: `<p>美食网红人设崩塌。一位在短视频平台拥有超过800万粉丝的美食网红，近日被知情人士爆料其精心打造的"家庭厨房"人设完全是虚假的。</p>
    <p>据爆料者提供的照片和视频显示，该网红真正的"工作厨房"卫生状况堪忧：食材随意堆放、厨具油污斑斑、甚至有蟑螂出没的痕迹。与其视频中展示的整洁明亮的厨房形成了鲜明对比。</p>
    <p>更令人震惊的是，该网红直播和短视频中展示的那些精致美食，实际上并非其亲手制作。据知情人士透露，真正的烹饪工作是由一个专业的美食制作团队在另一个干净整洁的厨房完成的，该网红只是在前端进行"表演"。</p>
    <p>这条爆料迅速在网络上引发轩然大波。大量粉丝表示感到被欺骗："我们一直以为她是真的热爱烹饪，没想到全是演的。"该网红的社交媒体账号在一夜之间掉粉超过50万。</p>
    <p>多个与该网红有合作关系的厨具和食品品牌也紧急发表声明，表示正在核实情况，并将根据调查结果决定是否继续合作。</p>`,
    categoryId: 'wanghong-baoliao',
    categoryName: '网红爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20contrast%20between%20a%20messy%20dirty%20kitchen%20and%20beautiful%20food%20photography%2C%20split%20composition%2C%20dramatic%20reveal%20concept%2C%20dark%20versus%20bright%20lighting%2C%20food%20influencer%20scandal%20theme%2C%20cinematic%20storytelling&width=800&height=500&seq=article-014-cover&orientation=landscape',
    author: '爆料小助手',
    publishedAt: '2026-07-31T11:00:00Z',
    updatedAt: '2026-07-31T17:00:00Z',
    viewCount: 234500,
    commentCount: 4321,
    tags: ['网红爆料', '人设崩塌', '美食网红'],
    isHot: false,
    isExclusive: false,
    readTime: 4,
  },
  {
    id: 'article-015',
    title: '某知名演员片场耍大牌被群演爆料：迟到早退态度恶劣',
    slug: 'zhi-ming-yanyuan-shuadapai',
    excerpt: '一位在某热门剧组担任群演的网友日前发文爆料，称剧组某知名主演在拍摄期间多次迟到早退、态度恶劣，甚至对工作人员恶语相向，引发了剧组成员的不满。',
    content: `<p>演员的职业素养再次成为热点话题。一位在某热门剧组工作过的群演近日在社交平台上发表长文，详细描述了该剧组某知名主演的种种"耍大牌"行为。</p>
    <p>据这位群演描述，该主演在整个拍摄周期内几乎没有准时到达过片场，每天的迟到时间从半小时到两小时不等。全剧组的工作人员和其他演员不得不为其一个人的迟到而等待，严重影响了拍摄进度。</p>
    <p>更令人气愤的是，该主演不仅迟到，还经常在拍摄未完成的情况下提前离开。有一次重要的群戏拍摄中，该主演拍完自己的特写镜头后就直接离开了，导致后续需要其参与的全景镜头只能使用替身完成。</p>
    <p>爆料还指出，该主演对工作人员的态度十分恶劣。曾有一位道具师因为一个小失误被其当众辱骂了十几分钟，甚至说出了"你这种人不配在这个行业"的侮辱性言论。</p>
    <p>该爆料在网络上迅速传播，引发了公众对演艺圈"耍大牌"现象的热议。不少业内人士也纷纷表示，这种行为不仅有损个人形象，也破坏了整个行业的职业风气。</p>`,
    categoryId: 'mingxing-bagua',
    categoryName: '明星八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20empty%20set%20with%20dramatic%20lighting%2C%20behind%20the%20scenes%20movie%20production%2C%20tense%20atmosphere%2C%20cinematic%20backstage%20aesthetic%2C%20warm%20film%20lights%20in%20dark%20studio&width=800&height=500&seq=article-015-cover&orientation=landscape',
    author: '片场观察者',
    publishedAt: '2026-07-30T13:00:00Z',
    updatedAt: '2026-07-31T08:00:00Z',
    viewCount: 312400,
    commentCount: 5342,
    tags: ['耍大牌', '演员', '片场爆料'],
    isHot: false,
    isExclusive: false,
    readTime: 5,
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categoryId: string): Article[] => {
  return articles.filter((a) => a.categoryId === categoryId);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((a) => a.isHot);
};

export const getExclusiveArticles = (): Article[] => {
  return articles.filter((a) => a.isExclusive);
};

export const getLatestArticles = (limit: number = 10): Article[] => {
  return [...articles].sort((a, b) =>
    new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  ).slice(0, limit);
};